// extracted by mini-css-extract-plugin
export default {"page":"integrations_page__Oce2E","title":"integrations_title__LqiSw"};